import { useCallback } from 'react';

import { classifyCombinablePromotions } from '@/components/blocks/FreeGiftV2/utils';
import { CombinablePromotion } from '@/data/types/Promotions';
import { useGetPromotionDetails } from 'presentation/events/hooks/useGetPromotionDetails';
import { useTrackException } from 'presentation/events/hooks/useTrackException';

import { SendAddToWishListEventProps, TrackAddToWishListProps } from './types';
import { useTrackAddToWishListGA4 } from './useTrackAddToWishListGA4';

export const useTrackAddToWishList = () => {
	const trackException = useTrackException();
	const getPromotionDetails = useGetPromotionDetails();
	const sendGA4Event = useTrackAddToWishListGA4();

	return useCallback(
		async ({ product, categories, quantity = 1, bundleId }: TrackAddToWishListProps) => {
			try {
				const promotionDetails = await getPromotionDetails({
					catentryId: product.id,
				});

				const promoThdCode = classifyCombinablePromotions(
					promotionDetails?.combinablePromotions as CombinablePromotion[] | undefined
				);

				const sendEventProps: SendAddToWishListEventProps = {
					product: { ...product, promoThdCode },
					categories,
					quantity,
					promotionDetails: promotionDetails ?? undefined,
					bundleId,
				};

				sendGA4Event(sendEventProps);
			} catch (e) {
				console.error('Error sending add to wish list event', e);
				trackException(e);
			}
		},
		[getPromotionDetails, sendGA4Event, trackException]
	);
};
